import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import Menu from './Components/Nav';
import { UserProvider } from './Hooks/userContext';
import { BrowserRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <div className='p-m-0 bw-background'>
          <Menu />
          <App className='wrapper' />
        </div>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
)